function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5347",
  "data-name": "Caminho 5347",
  d: "M-113.542,316.945h24.912a4.677,4.677,0,0,0,4.671-4.671V296.7a4.679,4.679,0,0,0-4.671-4.671h-24.912a4.679,4.679,0,0,0-4.671,4.671v15.571A4.677,4.677,0,0,0-113.542,316.945Zm26.469-5.32-7.139-7.138,7.139-7.139Zm-17.316-3.566a4.656,4.656,0,0,0,3.3,1.366,4.656,4.656,0,0,0,3.3-1.366l1.37-1.37,7.142,7.142H-112.9l7.142-7.142Zm4.4-2.2a1.558,1.558,0,0,1-2.2,0l-10.71-10.71h23.622Zm-7.976-1.37-7.138,7.138V297.349Z",
  transform: "translate(118.213 -292.033)",
  fill: "#fff"
});

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.255,
    height: 24.912,
    viewBox: "0 0 34.255 24.912",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.c5a8844c.svg";
export { ForwardRef as ReactComponent };